import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { CreateRegistrationDomainData, PatchRegistrationDomainData, RegistrationDomain, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function registrationDomain(config) {
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(RegistrationDomain)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RegistrationDomain))),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(RegistrationDomain)),
    });
    return Object.freeze({
        /**
         * Create a new registration domain rule.
         *
         * The request body is a tagged union discriminated on the `type` field:
         *
         * - `allow`: maps a domain to a tenant role (requires `tenant_role_id`). - `block`: blocks registration for a domain globally.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The created registration domain rule.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/registration_domains/`, createResponse.v, JSON.stringify(CreateRegistrationDomainData.encode(requestBody)));
            return result;
        },
        /**
         * List registration domain rules.
         *
         * @param arg The arguments to the function.
         * @param arg.tenantId If given, only return results for the given tenant.
         * @param arg.domain If given, filter by domain substring (case-insensitive).
         * @param arg.pageSize The size of a single page, maximum is 100.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns Paginated list of registration domain rules.
         */
        getAll: async ({ tenantId = undefined, domain = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/registration_domains/`, getAllResponse.v, undefined, {
                tenant_id: tenantId,
                domain,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Delete a registration domain rule.
         *
         * @param arg The arguments to the function.
         * @param arg.domainId The id of the rule to delete.
         * @returns Empty response.
         */
        delete: async ({ domainId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/registration_domains/${domainId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Update an existing registration domain rule.
         *
         * All fields are optional — only the provided fields are updated.
         *
         * @param arg The arguments to the function.
         * @param arg.domainId The id of the rule to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated registration domain rule.
         */
        patch: async ({ domainId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/registration_domains/${domainId}`, patchResponse.v, JSON.stringify(PatchRegistrationDomainData.encode(requestBody)));
            return result;
        },
    });
}
